import { defaults } from "@videojs/utils/object";
//#region src/core/ui/controls/core.ts
/** @internal */
var ControlsCore = class ControlsCore {
	static defaultProps = { visibility: "auto" };
	#props = { ...ControlsCore.defaultProps };
	#media = null;
	constructor(props) {
		if (props) this.setProps(props);
	}
	setProps(props) {
		this.#props = defaults(props, ControlsCore.defaultProps);
	}
	setMedia(media) {
		this.#media = media;
	}
	getState() {
		const media = this.#media;
		if (!media) return this.#props.visibility === "always" ? {
			visible: true,
			userActive: true
		} : null;
		return {
			visible: this.#props.visibility === "always" || media.controlsVisible,
			userActive: media.userActive
		};
	}
};
//#endregion
export { ControlsCore };
